/* eslint react-hooks/exhaustive-deps: "warn" */

import { type ReactNode } from 'react';

import { HeroSection } from 'ui/molecules/HeroSection/HeroSection';

import { AskRegisInput } from 'features/agents/organisms/AskRegisInput/AskRegisInput';

import styles from './AIProductHeroSection.module.scss';

const CHIPS = [
  'Who owns Revolut?',
  'Find companies in UK, SIC: 643 - Trusts, funds and similar financial entities',
  'Verify VAT FR92057505539',
  'Bosch GmbH financials, last 5 years',
];

const DEFAULT_TITLE = 'Regis reads the registry.';

const DEFAULT_DESCRIPTION = (
  <>
    An AI trained strictly on official government registries — verify any company and pull financials, directors,
    shareholders, UBOs and corporate linkages across <strong>600M+ companies.</strong>
  </>
);

type AIProductHeroSectionProps = {
  title?: ReactNode;
  description?: ReactNode;
  chips?: string[];
  /** Media node under the search box. Omit for the default customers strip; pass `null` to hide. */
  media?: ReactNode;
  background?: string;
};

export const AIProductHeroSection = ({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  chips = CHIPS,
  media,
  background,
}: AIProductHeroSectionProps = {}) => (
  <div className={styles.container} style={background ? { background } : undefined}>
    <HeroSection
      title={title}
      descriptionClassName={styles.description}
      description={description}
      extra={<AskRegisInput chips={chips} />}
      media={media}
      mediaPosition="bottom"
    />
  </div>
);
